import { from, Observable } from 'rxjs';

import { switchMap, tap } from 'rxjs/operators';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { CommonDataService } from '@sb-tools/typescript/services/common-data.service';
import { AuthenticationService } from '@sb-tools/typescript/authentication/authentication.service';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '@environment';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
    constructor(
        private authenticationService: AuthenticationService,
        private translateService: TranslateService,
        private commonDataService: CommonDataService,
    ) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let headers = req.headers.set('Version', environment.apiVersion);

        if (this.isNeedAuthApi(req.url)) {
            const community = this.commonDataService.communityName || this.authenticationService.community;

            return from(this.authenticationService.getAuthorizationHeader(community)).pipe(
                switchMap((data) => {
                    headers = headers.set('Authorization', data.toString()).set('Community', community);
                    // .append('Content-Type', 'application/json');

                    const clonedRequest = req.clone({
                        headers,
                    });

                    // Pass the cloned request instead of the original request to the next handle
                    return next.handle(clonedRequest).pipe(
                        tap((event) => {
                            return this.setServerTime(event);
                        }),
                    );
                }),
            );
        } else {
            const clonedRequest = req.clone({
                headers,
            });
            // Pass the cloned request instead of the original request to the next handle
            return next.handle(clonedRequest).pipe(
                tap((event) => {
                    return this.setServerTime(event);
                }),
            );
        }
    }

    private isNeedAuthApi(requestUrl: string) {
        const requestUrlLower = requestUrl.toLowerCase();

        return (
            requestUrlLower.indexOf(environment.apiInboxUrl.toLowerCase()) === 0 ||
            requestUrlLower.indexOf(environment.apiMasterUrl.toLowerCase()) === 0 ||
            requestUrlLower.indexOf(environment.apiFormUrl.toLowerCase()) === 0 ||
            requestUrlLower.indexOf(environment.apiFaqUrl.toLowerCase()) === 0 ||
            requestUrlLower.indexOf(environment.uploadsUrl.toLowerCase()) === 0 ||
            (environment.signalrServerUrl && requestUrlLower.indexOf(environment.signalrServerUrl.toLowerCase()) === 0)
        );
    }

    private setServerTime(event) {
        if (event.type !== 0 && event['url']?.toLowerCase().indexOf(environment.apiMasterUrl.toLowerCase()) === 0) {
            const serverTime = event['headers'].get('date');
            this.authenticationService.setTimeDifference(serverTime);
        }
    }
}
